import { render, staticRenderFns } from "./systemicData.vue?vue&type=template&id=073d39b3"
import script from "./systemicData.vue?vue&type=script&lang=js"
export * from "./systemicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports